"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ruleset = undefined;

var _util = require("../../../../util");

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//import * as Overlord from "./overlord"
var TS = Util.Timestamp.wrap;

var TS0 = TS(0);

var ruleset = exports.ruleset = {};
exports.default = [{
  name: "standard",
  ruleset: ruleset,
  lifecycle: {
    visibleAt: TS0,
    openAt: TS0
  }
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvbGVhZ3Vlcy9saXN0L3N0YW5kYXJkLmpzIl0sIm5hbWVzIjpbIlV0aWwiLCJUUyIsIlRpbWVzdGFtcCIsIndyYXAiLCJUUzAiLCJydWxlc2V0IiwibmFtZSIsImxpZmVjeWNsZSIsInZpc2libGVBdCIsIm9wZW5BdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztJQUFZQSxJOzs7O0FBR1o7QUFDQSxJQUFNQyxLQUFLRCxLQUFLRSxTQUFMLENBQWVDLElBQTFCOztBQUNBLElBQU1DLE1BQU1ILEdBQUcsQ0FBSCxDQUFaOztBQUVPLElBQU1JLDRCQUFtQixFQUF6QjtrQkFJUyxDQUNkO0FBQ0VDLFFBQU0sVUFEUjtBQUVFRCxrQkFGRjtBQUdFRSxhQUFXO0FBQ1RDLGVBQVdKLEdBREY7QUFFVEssWUFBUUw7QUFGQztBQUhiLENBRGMsQyIsImZpbGUiOiJzdGFuZGFyZC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBVdGlsIGZyb20gXCIuLi8uLi8uLi8uLi91dGlsXCJcbmltcG9ydCB0eXBlIHtTdGF0ZSBhcyBMZWFndWV9IGZyb20gXCIuLi9yYXdcIlxuaW1wb3J0IHR5cGUge1N0YXRlIGFzIFJ1bGVzZXR9IGZyb20gXCIuLi9ydWxlc2V0c1wiXG4vL2ltcG9ydCAqIGFzIE92ZXJsb3JkIGZyb20gXCIuL292ZXJsb3JkXCJcbmNvbnN0IFRTID0gVXRpbC5UaW1lc3RhbXAud3JhcFxuY29uc3QgVFMwID0gVFMoMClcblxuZXhwb3J0IGNvbnN0IHJ1bGVzZXQ6IFJ1bGVzZXQgPSB7XG4gIC8vdW5sb2NrWm9uZTY6IE92ZXJsb3JkLmNsb3NlZEF0LFxuICAvL3R3aW5NZWF0VXBncmFkZXM6IE92ZXJsb3JkLmNsb3NlZEF0LFxufVxuZXhwb3J0IGRlZmF1bHQgKFtcbiAge1xuICAgIG5hbWU6IFwic3RhbmRhcmRcIixcbiAgICBydWxlc2V0LFxuICAgIGxpZmVjeWNsZToge1xuICAgICAgdmlzaWJsZUF0OiBUUzAsXG4gICAgICBvcGVuQXQ6IFRTMCxcbiAgICB9LFxuICB9LFxuXTogTGVhZ3VlW10pXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/leagues/list/standard.js
// module id = 781
// module chunks = 0